<div [chart]="chart" class="hours-per-accent-pie-chart"></div>